import Api from "../../api";

import { Notice, NoticeCategory } from "./models.jsx";

const requestsUrl = "requests";
const categoriesUrl = "categories";
const contentUrl = "content";

class NoticesApi extends Api {

	getById(noticeId, callback) {

	    var url = this.baseUrl + requestsUrl + "/" + noticeId;

	    this.client.get(url).then((response) => {
	    	callback({ 
	    		result: new Notice(response.data), 
	    		error: null
	    	});
	    }).catch((error) => {
	    	callback({ 
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });
	}

	getPage(startItem, endItem, keyword, state, sort, callback) {

	    var url = this.baseUrl + requestsUrl;
	    this.client.get(url, { 
	    	headers: {"Range": "items=" + startItem + "-" + endItem},
	    	params: { state: state, sort: sort, keyword: keyword }
	    }).then((response) => {
			var rangeHeader = response.headers["range"];
			var total = parseInt(rangeHeader.split("/")[1]);

			var data = [];
			for (var index = 0; index < response.data.length; index++) {
				data.push(new Notice(response.data[index]));
			}

	    	callback({ 
	    		result: { data: data, total: total }, 
	    		error: null
	    	});
	    }).catch((error) => {
	    	callback({ 
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });
	}

	
	create(notice, callback) {
		var url = this.baseUrl + requestsUrl;
		this.client.post(url, notice)
			.then((response) => {
				callback({
					result: new Notice(response.data),
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

	update(notice, callback) {
		var url = this.baseUrl + requestsUrl + "/" + notice.id;
		this.client.put(url, notice)
			.then((response) => {
				callback({
					result: new Notice(response.data),
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

	getMedia(noticeId, binId, callbacks) {
	    let url = this.getMediaUrl(noticeId, binId);
	    this.loadBinary(url, callbacks);
	}

	getMediaUrl(noticeId, binId) {
	    return this.baseUrl + requestsUrl + "/" + noticeId + "/" + contentUrl + "/" + binId;
	}
}


class CategoriesApi extends Api {

	get(deactivated, callback) {

	    var url = this.baseUrl + categoriesUrl;

	    this.client.get(url, {
	    	params: { deactivated: deactivated }
	    }).then((response) => {
			var data = [];
			for (var index = 0; index < response.data.length; index++) {
				data.push(new NoticeCategory(response.data[index]));
			}

	    	callback({ 
	    		result: data, 
	    		error: null
	    	});

	    }).catch((error) => {
	    	callback({ 
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });
	}

	update(category, callback) {
	    var url = this.baseUrl + categoriesUrl + "/" + category.id;
	    this.client.put(url, category).then((response) => {
	    	callback({ 
	    		result: new NoticeCategory(response.data), 
	    		error: null
	    	});
	    }).catch((error) => {
	    	callback({ 
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });
	}

	create(category, callback) {
		var url = this.baseUrl + categoriesUrl;
	    this.client.post(url, category).then((response) => {
	    	callback({ 
	    		result: new NoticeCategory(response.data), 
	    		error: null
	    	});
	    }).catch((error) => {
	    	callback({ 
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });
	}

}

class NoticesServiceApi{

	constructor(baseUrl) {
		this.notices = new NoticesApi(baseUrl);
		this.categories = new CategoriesApi(baseUrl);
	}

}

export default NoticesServiceApi;